import { PersonalAnalysticsService } from './../../../data/repository/analytics-repository/personal-analystics.service';
import { PersonalDataService } from './../../../data/repository/plan-repository/personal-data.service';
import { CalendarShared } from './../../general/shared/calendar-shared';
import { AddFoodLogInputModel } from './../../../core/model/input/food-log-input-model';
import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { FoodUnitRatioModel } from 'src/app/core/model/object/diet-food-model';
import { TextHelper } from 'src/app/utils/text-helper';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { WebengageService } from 'src/app/data/repository/analytics-repository/webengage.service';

@Component({
  selector: 'app-add-food-bottomsheet',
  templateUrl: './add-food-bottomsheet.component.html',
  styleUrls: ['./add-food-bottomsheet.component.scss'],
})
export class AddFoodBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  packageClicked: boolean = false;
  foodCliked: boolean = false;
  calorie = 0;
  gram = 0;
  amount: string;
  selectedRatio: string;
  ratios: string[];
  isButtonActive = false;
  isCreatePerosnalPackage: boolean = false;
  isEditPeronalPackageEdit: boolean = false;
  showLoading = false;
  activeMeal: boolean = false;
  selectMeal: boolean = false;
  selectedMeal = [false, false, false, false, false, false];
  addPackage: boolean = false;
  meal: string = 'صبحانه';
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<AddFoodBottomsheetComponent>,
    private textHelper: TextHelper,
    private planService: PlanService,
    private snackBarService: SnackBarService,
    private cdRef: ChangeDetectorRef,
    private diaryAnalytics: DiaryAnalyticsService,
    private calendarShared: CalendarShared,
    private personalDataService: PersonalDataService,
    private personalAnalysticsService: PersonalAnalysticsService,
    private webengage: WebengageService
  ) {
    this.isCreatePerosnalPackage = this.data.isCreatePerosnalPackage
      ? true
      : false;
    this.isEditPeronalPackageEdit = this.data.isEditPeronalPackageEdit
      ? true
      : false;
    this.addPackage = this.data.peronalPackage ? true : false;

    if (this.isEditPeronalPackageEdit) {
      this.amount = this.data.amount;
      this.calculateCalorie();
    }
    if (this.addPackage) {
      if (this.data.meal == 'breakfast') {
        this.meal = 'صبحانه';
      } else if (this.data.meal == 'snack1') {
        this.meal = ' میان‌وعده اول';
      } else if (this.data.meal == 'lunch') {
        this.meal = 'ناهار';
      } else if (this.data.meal == 'snack2') {
        this.meal = ' میان‌وعده دوم';
      } else if (this.data.meal == 'dinner') {
        this.meal = ' شام';
      } else if (this.data.meal == 'snack3') {
        this.meal = ' میان‌وعده سوم';
      }
    }
  }

  ngOnInit() {
    if (!this.addPackage) {
      this.setFoodRatios();
    }
  }
  addingPackage() {
    if (!this.packageClicked) {
      let time = this.calendarShared.selectedDate.getTime();
      if (!time) {
        time = new Date(new Date().setHours(0, 0, 1, 0)).getTime();
      }
      this.packageClicked = true;
      const foodlogList = this.data.package.foods.map((v) => {
        return new AddFoodLogInputModel(
          time,
          parseInt(this.textHelper.replacePersian(v.amount.toString())),
          v.food._id,
          this.data.meal,
          v.primaryFoodUnit,
          ''
        );
      });
      this.planService.addFood(foodlogList, true).then((res) => {
        if (res.isSuccess()) {
          this.personalAnalysticsService.analyticAddPersonalPackage();
          this.showLoading = false;
          this.cdRef.detectChanges();
          this.bottomSheetRef.dismiss();
          this.snackBarService.showSnackBar(res.getData().getMessage());
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.showLoading = false;
          this.packageClicked = false;
          this.cdRef.detectChanges();
          this.bottomSheetRef.dismiss();
        }
      });
    }
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  close() {
    this.bottomSheetRef.dismiss();
  }
  calculateCalorie() {
    if (this.amount && this.amount !== '') {
      this.amount = this.textHelper.replacePersian(this.amount);
    }
    if (this.amount && this.amount !== '0') {
      let ratio: FoodUnitRatioModel;
      let isGram = false;
      if (
        this.data.food.primaryFoodUnit === '' ||
        this.data.food.primaryFoodUnit === '5e1c595d883a966e03fb4530'
      ) {
        isGram = true;
      }
      if (isGram) {
        this.gram = -1;
        this.calorie =
          (this.data.food.foodFact.calorieAmount * parseFloat(this.amount)) /
          100;
        if (parseFloat(this.amount)) {
          this.isButtonActive = true;
        } else {
          this.isButtonActive = false;
        }
      } else {
        this.data.food.foodUnitRatioArray.forEach((r) => {
          if (r.unitId._id === this.data.food.primaryFoodUnit) {
            ratio = r;
          }
        });
        this.gram = ratio.ratio * parseFloat(this.amount);
        this.calorie =
          ((this.data.food.foodFact.calorieAmount * parseFloat(this.amount)) /
            100) *
          ratio.ratio;
        if (parseFloat(this.amount)) {
          this.isButtonActive = true;
        } else {
          this.isButtonActive = false;
        }
      }
    } else {
      this.calorie = 0;
      this.isButtonActive = false;
    }
    if (parseFloat(this.amount)) {
      setTimeout(() => {
        const width = document
          .getElementById('add-food-calorie')
          .getBoundingClientRect().width;
        document.getElementById('add-food-name').style.width =
          'calc( 100% - 48px - ' + width.toString() + 'px )';
      }, 100);
    }
  }

  setFoodRatios() {
    this.ratios = [];
    if (
      this.data.food.primaryFoodUnit === '' ||
      this.data.food.primaryFoodUnit === '5e1c595d883a966e03fb4530'
    ) {
      this.selectedRatio = 'گرم';
    }
    this.data.food.foodUnitRatioArray.forEach((r) => {
      this.ratios.push(r.unitId.name);
      if (r.unitId._id === this.data.food.primaryFoodUnit) {
        this.selectedRatio = r.unitId.name;
      }
    });
    this.ratios.push('گرم');
  }

  onRatioChange() {
    if (this.selectedRatio === 'گرم') {
      this.data.food.primaryFoodUnit = '5e1c595d883a966e03fb4530';
    }
    this.data.food.foodUnitRatioArray.forEach((r) => {
      if (r.unitId.name === this.selectedRatio) {
        this.data.food.primaryFoodUnit = r.unitId._id;
      }
    });
    this.calculateCalorie();
  }
  async AddpersonalFood() {
    if (this.activeMeal && !this.foodCliked) {
      this.foodCliked = true;
      const meals = [];
      if (this.selectedMeal[0]) {
        meals.push('breakfast');
      }
      if (this.selectedMeal[1]) {
        meals.push('snack1');
      }
      if (this.selectedMeal[2]) {
        meals.push('lunch');
      }
      if (this.selectedMeal[3]) {
        meals.push('snack2');
      }
      if (this.selectedMeal[4]) {
        meals.push('dinner');
      }
      if (this.selectedMeal[5]) {
        meals.push('snack3');
      }
      const foodlogList = meals.map(
        (d) =>
          new AddFoodLogInputModel(
            this.calendarShared.selectedDate.getTime(),
            parseInt(this.textHelper.replacePersian(this.amount.toString())),
            this.data.food._id,
            d,
            this.data.food.primaryFoodUnit,
            ''
          )
      );

      await this.planService.addFood(foodlogList, true).then((res) => {
        if (res.isSuccess()) {
          this.showLoading = false;
          this.cdRef.detectChanges();
          this.bottomSheetRef.dismiss();
          this.personalAnalysticsService.analyticAddPersonalFood();
          this.webengage.addFoodLog(foodlogList[0].meal, 'personal');
          this.snackBarService.showSnackBar(res.getData().getMessage());
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.showLoading = false;
          this.foodCliked = false;
          this.cdRef.detectChanges();
          this.bottomSheetRef.dismiss();
        }
      });
    }
  }
  addFood() {
    if (this.isButtonActive) {
      // this.animateButton();
      if (this.isCreatePerosnalPackage || this.isEditPeronalPackageEdit) {
        this.personalDataService.addPersonalPackage(
          this.data.food,
          parseInt(this.amount)
        );
        this.cdRef.detectChanges();
        this.bottomSheetRef.dismiss();
      } else if (!this.data.peronalFood) {
        let time = this.calendarShared.selectedDate?.getTime();
        const foodlogList = [
          new AddFoodLogInputModel(
            time ? time : new Date().getTime(),
            parseInt(this.textHelper.replacePersian(this.amount.toString())),
            this.data.food._id,
            this.data.meal,
            this.data.food.primaryFoodUnit,
            ''
          ),
        ];
        this.planService.addFood(foodlogList, true).then((res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageFoodAdded();
            this.webengage.addFoodLog(foodlogList[0].meal, 'food');

            this.showLoading = false;
            this.cdRef.detectChanges();
            this.bottomSheetRef.dismiss();
            this.snackBarService.showSnackBar(res.getData().getMessage());
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
            this.showLoading = false;
            this.cdRef.detectChanges();
          }
        });
      } else {
        this.selectMeal = true;
        this.data.food.name = 'افزودن غذای شخصی';
      }
    }
  }
  remove() {
    this.cdRef.detectChanges();
    this.bottomSheetRef.dismiss();
    this.personalDataService.closeAndRemove(this.data.food.id);
  }
  onChangemealSelect(e) {
    let mealsL = this.selectedMeal.map((v) => v !== false);
    if (mealsL.length > 0) {
      this.activeMeal = true;
    }
  }
  animateButton() {
    const button = document.getElementById('add-button');
    button.style.width = '56px';
    button.style.right = 'calc( 50% - 28px )';
    setTimeout(() => {
      this.showLoading = true;
      this.cdRef.detectChanges();
    }, 200);
  }

  convertStringToNumber(s: string) {
    return parseFloat(s);
  }
}
